import {
  GET_SUB_DATA,
  GET_SUB_DATA_SUCCESS,
  GET_SUB_DATA_FAIL,
  GET_LAST_SUB_DATA,
  GET_LAST_SUB_DATA_SUCCESS,
  GET_LAST_SUB_DATA_FAIL,
  GET_AGG_SUB_DATA,
  GET_AGG_SUB_DATA_SUCCESS,
  GET_AGG_SUB_DATA_FAIL
} from '../constants/sub';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          loaded: false,
          data: null,
          error: null
        }
      };
    case GET_SUB_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: false,
          data: null,
          error: action.error
        }
      };
    case GET_SUB_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    case GET_LAST_SUB_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          lastLoaded: false,
          error: null
        }
      };
    case GET_LAST_SUB_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          lastLoaded: false,
          error: action.error
        }
      };
    case GET_LAST_SUB_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          lastLoaded: true,
          lastData: action.lastData,
          error: null
        }
      };
    case GET_AGG_SUB_DATA:
      return {
        ...state,
        loading: true,
        aggLoaded: false,
        error: null
      };
    case GET_AGG_SUB_DATA_FAIL:
      return {
        ...state,
        loading: false,
        aggLoaded: false,
        allData: null,
        error: action.error
      };
    case GET_AGG_SUB_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        aggLoaded: true,
        allData: action.data,
        error: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/sub.js